import { abrirLandingServico } from '@modules/solicitacoes/utils/landingServico/landingServico'
import { CONSULTOR_ERRO_ABRIR_LANDING } from '@modules/solicitacoes/constants/Text'

/**
 * Abre a landing do serviço que a IA citou, com o feedback e a telemetria da
 * superfície que chamou.
 *
 * Mora em `solicitacoes` e não no módulo do chat DE PROPÓSITO: o motor de IA não
 * conhece a Jornada — ele EMITE `open-service` e quem navega é quem tem o mapa
 * de landings. Se isto morasse em `aawz-intelligence-v2`, o módulo do chat
 * importaria de `solicitacoes`, que é a direção errada da dependência.
 *
 * Existia em TRÊS cascas com o mesmo corpo, variando só os dois valores do
 * gtag — e a terceira (o painel do Hub) tinha o guard invertido e não emitia
 * telemetria nenhuma, então cliques por ali não eram medidos.
 *
 * `tipo` leva o CÓDIGO do catálogo (ex.: "6.3"), nunca o UUID: é o que a
 * allow-list de `plugins/observability.js` aceita.
 *
 * @param {Object} vm Instância Vue da casca — precisa de `$showSnack` e `$gtagEvent`.
 * @param {Object} payload `{ idTipo, codigo, nome }` emitido pelo motor.
 * @param {Object} telemetria `{ module, action }` da superfície que chamou.
 * @returns {Boolean} `true` quando a landing abriu.
 */
export function abrirServicoCitado(vm, payload, { module, action } = {}) {
  if (!payload || !payload.idTipo) return false

  if (!abrirLandingServico({ idTipo: payload.idTipo })) {
    // Bloqueador de pop-up é a causa mais comum, e o gestor só resolve se
    // souber onde olhar.
    vm.$showSnack({
      text: CONSULTOR_ERRO_ABRIR_LANDING,
      color: 'error',
      button: true,
    })
    return false
  }

  if (module && action) {
    vm.$gtagEvent({
      module: module,
      action: action,
      value: 1,
      additionalParams: { tipo: payload.codigo },
    })
  }
  return true
}
